import React from "react";
import { useNavigate } from 'react-router-dom';
import ListVpsOnPage from "../ListVpsOnPage";

const PageListVpsOn = () => {
    const navigate = useNavigate();

    let redirectChangeUser = (listVps) => {
        navigate('/dich-vu-vps/chuyen-khach-hang.html?' + listVps);
    }

    let redirectExportExcel = (listVps) => {
        navigate('/dich-vu-vps/xuat-file-excel.html?' + listVps);
    }

    return <ListVpsOnPage
        redirectChangeUser={ (listVps) => redirectChangeUser(listVps) }
        redirectExportExcel={ (listVps) => redirectExportExcel(listVps) }
    />

}

export default PageListVpsOn;